import _regeneratorRuntime from "/Users/professor/WebstormProjects/string_table_converter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/Users/professor/WebstormProjects/string_table_converter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _this = this;

/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
import * as tslib_1 from "tslib";
/**
 * @constant
 * To generate the UUID
 * @returns The UUID string
 */

export var generateUUID = function generateUUID() {
  var uuid = "";

  for (var j = 0; j < 32; j++) {
    if (j === 8 || j === 12 || j === 16 || j === 20) {
      uuid += "-";
    }

    uuid += Math.floor(Math.random() * 16).toString(16);
  }

  return uuid;
};
/**
 * @constant
 * To get the request header from the request
 * @param {RequestInfo} request - The request object or the url string
 * @param {FetchOptions|undefined} options - The request options object
 * @param {string} key - The header key string
 * @returns A header value for the given key from the request
 */

export var getRequestHeader = function getRequestHeader(request, options, key) {
  var value = null;

  if (typeof Request !== "undefined" && request instanceof Request) {
    value = request.headers.get(key);
  } else if (typeof options !== "undefined" && options.headers !== undefined) {
    if (typeof Headers !== "undefined" && options.headers instanceof Headers) {
      value = options.headers.get(key);
    } else if (options.headers instanceof Array) {
      var headers = options.headers;

      for (var i = 0, l = headers.length; i < l; i++) {
        if (headers[i][0] === key) {
          value = headers[i][1];
          break;
        }
      }
    } else if (options.headers[key] !== undefined) {
      value = options.headers[key];
    }
  }

  return value;
};
/**
 * @constant
 * To set the header value to the given request
 * @param {RequestInfo} request - The request object or the url string
 * @param {FetchOptions|undefined} options - The request options object
 * @param {string} key - The header key string
 * @param {string } value - The header value string
 * @returns Nothing
 */

export var setRequestHeader = function setRequestHeader(request, options, key, value) {
  if (typeof Request !== "undefined" && request instanceof Request) {
    request.headers.set(key, value);
  } else if (typeof options !== "undefined") {
    if (options.headers === undefined) {
      options.headers = new Headers(_defineProperty({}, key, value));
    } else {
      if (typeof Headers !== "undefined" && options.headers instanceof Headers) {
        options.headers.set(key, value);
      } else if (options.headers instanceof Array) {
        var i = 0;
        var l = options.headers.length;

        for (; i < l; i++) {
          var header = options.headers[i];

          if (header[0] === key) {
            header[1] = value;
            break;
          }
        }

        if (i === l) {
          options.headers.push([key, value]);
        }
      } else {
        Object.assign(options.headers, _defineProperty({}, key, value));
      }
    }
  }
};
/**
 * @constant
 * To append the header value to the given request
 * @param {RequestInfo} request - The request object or the url string
 * @param {FetchOptions|undefined} options - The request options object
 * @param {string} key - The header key string
 * @param {string } value - The header value string
 * @returns Nothing
 */

export var appendRequestHeader = function appendRequestHeader(request, options, key, value) {
  if (typeof Request !== "undefined" && request instanceof Request) {
    request.headers.append(key, value);
  } else if (typeof options !== "undefined") {
    if (options.headers === undefined) {
      options.headers = new Headers(_defineProperty({}, key, value));
    } else {
      if (typeof Headers !== "undefined" && options.headers instanceof Headers) {
        options.headers.append(key, value);
      } else if (options.headers instanceof Array) {
        options.headers.push([key, value]);
      } else if (options.headers === undefined) {
        options.headers = _defineProperty({}, key, value);
      } else if (options.headers[key] === undefined) {
        options.headers[key] = value;
      } else {
        options.headers[key] += ", ".concat(value);
      }
    }
  }
};
/**
 * @constant
 * To clone the request with the new url
 * @param {string} url - The new url string
 * @param {Request} request - The request object
 * @returns A promise that resolves to request object
 */

export var cloneRequestWithNewUrl = function cloneRequestWithNewUrl(newUrl, request) {
  return tslib_1.__awaiter(_this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var body, method, headers, referrer, referrerPolicy, mode, credentials, cache, redirect, integrity, keepalive, signal;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!request.headers.get("Content-Type")) {
              _context.next = 6;
              break;
            }

            _context.next = 3;
            return request.blob();

          case 3:
            _context.t0 = _context.sent;
            _context.next = 9;
            break;

          case 6:
            _context.next = 8;
            return Promise.resolve(undefined);

          case 8:
            _context.t0 = _context.sent;

          case 9:
            body = _context.t0;
            method = request.method, headers = request.headers, referrer = request.referrer, referrerPolicy = request.referrerPolicy, mode = request.mode, credentials = request.credentials, cache = request.cache, redirect = request.redirect, integrity = request.integrity, keepalive = request.keepalive, signal = request.signal;
            return _context.abrupt("return", new Request(newUrl, {
              method: method,
              headers: headers,
              body: body,
              referrer: referrer,
              referrerPolicy: referrerPolicy,
              mode: mode,
              credentials: credentials,
              cache: cache,
              redirect: redirect,
              integrity: integrity,
              keepalive: keepalive,
              signal: signal
            }));

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};